module.exports = __webpack_public_path__ + "static/img/weiboNews_04.9e214ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weibo/weiboNews_04.jpg
// module id = 1jSa
// module chunks = 0